import React, { Component } from 'react';
import firebase, { auth, provider } from './firebase.js';
import { Route, Switch } from 'react-router-dom'
import './styles/App.css';

import Header from './components/header';
import Footer from './components/footer';

import Profile from './containers/profile.js';
import Dashboard from './containers/dashboard.js';
import DocumentNew from './containers/documentNew.js';
import DocumentDataLoader from './containers/documentDataLoader.js';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      user: null,
      userProfile: {  }
    }; // <- set up react state
    this.login = this.login.bind(this); // <-- add this line
    this.logout = this.logout.bind(this); // <-- add this line
  }

  componentWillMount(){
    //reference to documents to state
    let documentsRef = firebase.database().ref('documents');
    //reference to user profile to state
    let profileRef = firebase.database().ref('users');

    firebase.auth().onAuthStateChanged(user =>  {
      console.log("componentWillMount");
      if (user) {
        //Read additional details for profile
        profileRef.child(user.uid).on('value', snapshot => {
          let profile = snapshot.val();
          if (profile !== null){
            this.setState({
              userProfile : profile
            })}
          else{
            this.newProfile(user);
          }
        })

        //read documents for each user
        documentsRef.child(user.uid).on('value', snapshot => {
          let documents = snapshot.val();
          if(!documents) {
            this.setState({
              documents: null
            })
            return;
          }
          let newState =[];
          for (let i in documents) {
            newState.push({
              id: i,
              data: documents[i].data,
              text: documents[i].text
            })
          }
          this.setState({
            documents: newState
          })
        });
      } else {
        // No user is signed in.
      }
    });
  }

  logout() {
    auth.signOut()
      .then(() => {
        this.setState({
          user: null,
          userProfile: null,
          documents: []
        });
      });
  }


  login() {
    auth.signInWithPopup(provider)
      .then((result) => {
        const user = result.user;
        this.setState({
          user: user,
          userProfile : user
        });
      });
  }


  newProfile(user){

  		const userRef = firebase.database().ref('users');

  		let newUserData = {
        id: user.uid,
  			name : user.displayName
  		}
  		userRef.child(user.uid).update(newUserData);
  }

  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      console.log("componentDidMount");
      if (user) {
        this.setState({
          user: user
        });
      }
      else {
        auth.signInAnonymously();
      }
    });
  }

  render() {
    /*if (!this.state.user) {
      return
        <button onClick={this.login}>KIRJAUDU SISÄÄN</button>
      );
    }*/
    return (
      <div className='mdl-layout'>
        <Header user={this.state.user} login={this.login} logout={this.logout}/>
        <div className='mdl-layout__content wrapper'>
          {this.state.documents === [] ?
            <div className="spinner"> {/* Loading icon */}
              <div className="rect1"></div>
              <div className="rect2"></div>
              <div className="rect3"></div>
              <div className="rect4"></div>
              <div className="rect5"></div>
            </div>
            : <Switch>
                <Route
                  exact path='/'
                  render={(props) => <Dashboard {...props} user={this.state.user} items={this.state.documents || []}/>}
                />
                <Route
                  path='/dashboard'
                  render={(props) => <Dashboard {...props} user={this.state.user} items={this.state.documents || []}/>}
                />
                <Route
                  path='/profile'
                  render={(props) => <Profile {...props} user={this.state.user}/>}
                />
                <Route
                  path='/newdocument'
                  render={(props) => <DocumentNew {...props} user={this.state.user} documents={this.state.documents}/>}
                />
                <Route
                  path='/document/:id'
                  render={(props) => <DocumentDataLoader {...props} user={this.state.user} documents={this.state.documents}/>}
                />
              </Switch>
          }
        </div>

        <Footer/>

      </div>
    );
  }
}

export default App;

/*


<header>


</header>
{this.state.user ?
  <div>
    <div className='container'>
      <ProfileContainer user={this.state.user} userProfile={this.state.userProfile}/>
      <PalveluehdotContainer user={this.state.user} items={this.state.items} userProfile={this.state.userProfile}/>
    </div>

  </div>
  :
  <div className='wrapper'>
    <p>Kirjaudu sisään ja osallistu villiin GDPR keskusteluun.</p>
  </div>
}

Messagejen lähettely


 Create reference to messages in Firebase Database
let messagesRef = firebase.database().ref('messages').orderByKey().limitToLast(100);


//read messages to state
messagesRef.on('value', snapshot => {
   Update React state when message is added at Firebase Database
  let data = snapshot.val();
  let newState = [];
  for (let i in data) {
    newState.push({
      id: i,
      message: data[i].message,
      user: data[i].user
    })
  }
  this.setState({
    messages: newState
  });
})

<section className='add-item'>
  <form onSubmit={this.addMessage.bind(this)}>
    <h4>Mitä ajattelet?</h4>
    <input type="text" ref={ el => this.inputEl = el }/>
    <input type="submit" value="Lähetä"/>
  </form>
</section>


Messagejen kattelu
{
  this.state.messages.map( message =>
    <li key={message.id}>
      <h3>{message.message}</h3>
      <p>Sent by {message.user}
        {message.user === this.state.user.displayName || message.user === this.state.user.email ?
        <button onClick={() => this.removeMessage(message.id)}>Remove</button> : null}
      </p>
    </li> )
}

addMessage(e){
  e.preventDefault(); // <- prevent form submit from reloading the page
   Send the message to Firebase
  const messageRef = firebase.database().ref('messages');
  const message = {
    message: this.inputEl.value,
    user: this.state.user.displayName || this.state.user.email
  }
  messageRef.push(message);
  //firebase.database().ref('messages').push( this.inputEl.value );
  this.inputEl.value = ''; // <- clear the input
}

removeMessage(itemId) {
const itemRef = firebase.database().ref(`/messages/${itemId}`);
itemRef.remove();
}

//Read profile to state
let profileRef = firebase.database().ref('users');

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    profileRef.child(user.uid).on('value', snapshot => {
      let profile = snapshot.val();
      console.log(profile);

      this.setState({
        userProfile : profile
      })

    })
  } else {
    // No user is signed in.
  }
});
*/



// WEBPACK FOOTER //
// ./src/App.js